import { Product } from "@/types";

export const products: Product[] = [
  {
    id: "1",
    name: "Organic Protein Powder",
    description: "Premium plant-based protein powder with 25g of protein per serving. Made with organic pea protein, brown rice protein, and hemp protein. Perfect for post-workout recovery and muscle building.",
    price: 39.99,
    image: "https://images.unsplash.com/photo-1504674900247-0877df9cc836?auto=format&fit=crop&w=600&q=80", // alternate
    category: "supplements"
  },
  {
    id: "2",
    name: "Omega-3 Supplements",
    description: "High-quality omega-3 fatty acid supplements sourced from sustainable fish oil. Supports heart health, brain function, and joint mobility. Each serving provides 1000mg of EPA and DHA.",
    price: 24.99,
    image: "https://images.unsplash.com/photo-1504674900247-0877df9cc836?auto=format&fit=crop&w=600&q=80",
    category: "supplements"
  },
  {
    id: "3",
    name: "Immunity Boosters",
    description: "Comprehensive immune support formula with Vitamin C, Zinc, and Elderberry extract. Helps strengthen your body's natural defenses and promotes overall wellness.",
    price: 19.99,
    image: "https://images.unsplash.com/photo-1502741338009-cac2772e18bc?auto=format&fit=crop&w=600&q=80",
    category: "supplements"
  },
  {
    id: "4",
    name: "Natural Sleep Aid",
    description: "Non-habit forming sleep supplement with Melatonin, Valerian Root, and Chamomile. Promotes restful sleep and helps you wake up refreshed.",
    price: 15.99,
    image: "https://images.unsplash.com/photo-1519125323398-675f0ddb6308?auto=format&fit=crop&w=600&q=80",
    category: "supplements"
  },
  {
    id: "5",
    name: "Resistance Bands Set",
    description: "Complete set of 5 resistance bands ranging from light to extra heavy resistance. Includes handles, ankle straps, and door anchor for a full-body workout anywhere.",
    price: 29.99,
    image: "https://images.unsplash.com/photo-1519864600265-abb23847ef2c?auto=format&fit=crop&w=600&q=80", // alternate
    category: "equipment"
  },
  {
    id: "6",
    name: "Premium Yoga Mat",
    description: "Extra thick (6mm) eco-friendly yoga mat with excellent grip and cushioning. Non-slip surface ensures stability during your practice. Includes carrying strap.",
    price: 49.99,
    image: "https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=600&q=80", // alternate
    category: "equipment"
  },
  {
    id: "7",
    name: "Smart Water Bottle",
    description: "Intelligent water bottle that tracks your hydration levels and glows to remind you when it's time to drink. Connects to your smartphone via Bluetooth for detailed hydration analytics.",
    price: 34.99,
    image: "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=600&q=80", // alternate
    category: "accessories"
  },
  {
    id: "8",
    name: "Adjustable Dumbbells",
    description: "Space-saving adjustable dumbbells that replace 15 sets of weights. Quick-change weight system allows you to adjust from 5 to 52.5 pounds with the turn of a dial.",
    price: 299.99,
    image: "https://images.unsplash.com/photo-1517960413843-0aee8e2b3286?auto=format&fit=crop&w=600&q=80", // alternate
    category: "equipment"
  },
  {
    id: "9",
    name: "Fitness Tracker Watch",
    description: "Advanced fitness tracker with heart rate monitoring, sleep tracking, and step counting. Syncs with your smartphone for detailed activity insights.",
    price: 89.99,
    image: "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?auto=format&fit=crop&w=600&q=80",
    category: "accessories"
  },
  {
    id: "10",
    name: "Compression Leggings",
    description: "High-performance compression leggings that improve blood circulation, reduce muscle fatigue, and provide a comfortable fit for workouts.",
    price: 59.99,
    image: "https://images.unsplash.com/photo-1512436991641-6745cdb1723f?auto=format&fit=crop&w=600&q=80",
    category: "apparel"
  },
  {
    id: "11",
    name: "Meal Prep Containers",
    description: "Set of 10 BPA-free meal prep containers with portion control compartments. Microwave, dishwasher, and freezer safe for convenient meal planning.",
    price: 19.99,
    image: "https://images.unsplash.com/photo-1504674900247-0877df9cc836?auto=format&fit=crop&w=600&q=80", // alternate
    category: "accessories"
  },
  {
    id: "12",
    name: "Foam Roller",
    description: "High-density foam roller for muscle recovery and myofascial release. Textured surface provides targeted pressure to help relieve muscle tension and improve flexibility.",
    price: 24.99,
    image: "https://images.unsplash.com/photo-1465101046530-73398c7f28ca?auto=format&fit=crop&w=600&q=80", // alternate
    category: "equipment"
  },
  {
    id: "13",
    name: "Creatine Monohydrate",
    description: "Pure micronized creatine monohydrate for increased strength, power, and muscle mass. Easily mixes with water or your favorite beverage. Unflavored and lab-tested for purity.",
    price: 22.99,
    image: "https://images.pexels.com/photos/5052085/pexels-photo-5052085.jpeg?auto=compress&w=600&q=80",
    category: "supplements"
  },
  {
    id: "14",
    name: "Pre-Workout Energizer",
    description: "Potent pre-workout formula with caffeine, beta-alanine, and citrulline malate for explosive energy, focus, and endurance. Sugar-free and available in multiple flavors.",
    price: 34.99,
    image: "https://images.pexels.com/photos/669577/pexels-photo-669577.jpeg?auto=compress&w=600&q=80",
    category: "supplements"
  },
  {
    id: "15",
    name: "BCAA Recovery Drink",
    description: "Delicious BCAA powder with a 2:1:1 ratio of leucine, isoleucine, and valine. Supports muscle recovery, reduces soreness, and helps prevent muscle breakdown during intense workouts.",
    price: 28.99,
    image: "https://images.pexels.com/photos/416717/pexels-photo-416717.jpeg?auto=compress&w=600&q=80",
    category: "supplements"
  },
  {
    id: "16",
    name: "Multivitamin for Athletes",
    description: "Comprehensive multivitamin specifically formulated for active individuals. Contains essential vitamins, minerals, and antioxidants to support energy, immunity, and recovery.",
    price: 18.99,
    image: "https://images.unsplash.com/photo-1502741338009-cac2772e18bc?auto=format&fit=crop&w=600&q=80",
    category: "supplements"
  },
  {
    id: "17",
    name: "Vegan Protein Bars (Box of 12)",
    description: "Plant-based protein bars packed with 15g of protein per bar. Made with natural ingredients, gluten-free, and perfect for on-the-go snacking or post-workout fuel.",
    price: 32.99,
    image: "https://images.pexels.com/photos/1153370/pexels-photo-1153370.jpeg?auto=compress&w=600&q=80",
    category: "supplements"
  },
  {
    id: "18",
    name: "Kettlebell Set (8, 12, 16 kg)",
    description: "Versatile kettlebell set for strength training, conditioning, and functional fitness. Includes three common weights for progressive workouts at home or in the gym.",
    price: 129.99,
    image: "https://images.unsplash.com/photo-1519864600265-abb23847ef2c?auto=format&fit=crop&w=600&q=80", // alternate
    category: "equipment"
  },
  {
    id: "19",
    name: "Pull-Up Bar (Doorway)",
    description: "Heavy-duty doorway pull-up bar for upper body workouts. Easy to install and remove, supports multiple grip positions for chin-ups, pull-ups, and hanging leg raises.",
    price: 39.99,
    image: "https://images.pexels.com/photos/1552106/pexels-photo-1552106.jpeg?auto=compress&w=600&q=80",
    category: "equipment"
  },
  {
    id: "20",
    name: "Speed Jump Rope",
    description: "Adjustable speed jump rope with lightweight handles and smooth ball bearings for fast, tangle-free rotations. Ideal for cardio, HIIT, and agility training.",
    price: 14.99,
    image: "https://images.pexels.com/photos/1552242/pexels-photo-1552242.jpeg?auto=compress&w=600&q=80",
    category: "equipment"
  },
  {
    id: "21",
    name: "Exercise Ball (Stability Ball)",
    description: "Anti-burst stability ball for core strengthening, balance, and flexibility exercises. Includes hand pump and workout guide. Available in multiple sizes.",
    price: 22.99,
    image: "https://images.pexels.com/photos/414029/pexels-photo-414029.jpeg?auto=compress&w=600&q=80",
    category: "equipment"
  },
  {
    id: "22",
    name: "Weightlifting Belt",
    description: "Durable weightlifting belt providing excellent lumbar support and stability for heavy lifts. Adjustable buckle and padded interior for comfort and safety.",
    price: 35.99,
    image: "https://images.pexels.com/photos/1552247/pexels-photo-1552247.jpeg?auto=compress&w=600&q=80",
    category: "equipment"
  },
  {
    id: "23",
    name: "Gym Bag with Shoe Compartment",
    description: "Spacious gym bag with a dedicated ventilated shoe compartment, multiple pockets, and a water-resistant exterior. Perfect for carrying all your workout essentials.",
    price: 45.99,
    image: "https://images.pexels.com/photos/1552241/pexels-photo-1552241.jpeg?auto=compress&w=600&q=80",
    category: "accessories"
  },
  {
    id: "24",
    name: "Workout Gloves (Weightlifting)",
    description: "Padded workout gloves with wrist support for enhanced grip and protection during weightlifting and cross-training. Breathable and easy to clean.",
    price: 19.99,
    image: "https://images.unsplash.com/photo-1519125323398-675f0ddb6308?auto=format&fit=crop&w=600&q=80", // alternate
    category: "accessories"
  },
  {
    id: "25",
    name: "Microfiber Gym Towel (Set of 2)",
    description: "Quick-drying and highly absorbent microfiber gym towels. Lightweight, compact, and ideal for wiping sweat during workouts or yoga sessions.",
    price: 17.99,
    image: "https://images.pexels.com/photos/703012/pexels-photo-703012.jpeg?auto=compress&w=600&q=80",
    category: "accessories"
  },
  {
    id: "26",
    name: "Shaker Bottle (Leakproof, 700ml)",
    description: "Leakproof shaker bottle with a mixing ball for smooth protein shakes and supplements. BPA-free, dishwasher safe, and fits most cup holders.",
    price: 12.99,
    image: "https://images.pexels.com/photos/1435134/pexels-photo-1435134.jpeg?auto=compress&w=600&q=80",
    category: "accessories"
  },
  {
    id: "27",
    name: "Running Armband for Phone",
    description: "Comfortable and secure running armband for smartphones. Sweat-proof with a clear touch-sensitive screen cover and adjustable strap for all arm sizes.",
    price: 16.99,
    image: "https://images.unsplash.com/photo-1465101178521-c1a9136a3fdc?auto=format&fit=crop&w=600&q=80", // alternate
    category: "accessories"
  },
  {
    id: "28",
    name: "Men's Performance T-Shirt",
    description: "Lightweight and breathable men's performance t-shirt made from moisture-wicking fabric. Keeps you cool and dry during intense workouts.",
    price: 29.99,
    image: "https://images.pexels.com/photos/936094/pexels-photo-936094.jpeg?auto=compress&w=600&q=80",
    category: "apparel"
  },
  {
    id: "29",
    name: "Women's Sports Bra (High Impact)",
    description: "High-impact sports bra offering maximum support and comfort. Breathable, moisture-wicking fabric with adjustable straps and removable padding.",
    price: 39.99,
    image: "https://images.pexels.com/photos/461421/pexels-photo-461421.jpeg?auto=compress&w=600&q=80",
    category: "apparel"
  },
  {
    id: "30",
    name: "Unisex Training Shorts",
    description: "Versatile training shorts with a comfortable fit and lightweight fabric. Features an elastic waistband, drawstring, and side pockets for convenience.",
    price: 25.99,
    image: "https://images.pexels.com/photos/1078983/pexels-photo-1078983.jpeg?auto=compress&w=600&q=80",
    category: "apparel"
  }
];


export const getProductById = (id: string): Product | undefined => {
  return products.find(product => product.id === id);
};

export const getProductsByCategory = (category: string): Product[] => {
  if (category === "all") return products;
  return products.filter(product => product.category === category);
};

export const getCategories = (): string[] => {
  const categories = new Set(products.map(product => product.category));
  return ["all", ...Array.from(categories)];
};